import { Link } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { getCurrentDepartment } from "../../../services/functions";
import { LogoVeterinary } from "./logo-veterinary";
import { LogoPetshop } from "./logo-petshop";

export function HeaderLogo() {
  const department = getCurrentDepartment()

  return (
    <div className="relative w-40 h-8">
      <AnimatePresence initial={false} mode="sync">
        {department === 'veterinary' && <LogoVeterinary key="logo-veterinary" />}
        {department === 'petShop' && <LogoPetshop key="logo-petshop" />}
      </AnimatePresence>
    </div>
  );
}
